// Single source of truth for the API origin the marketing site talks to.
//
// V1 served marketing + the API from ONE origin (tempdash.app), so its
// fetch calls used same-origin relative paths ('/api/marketing/waitlist')
// and Caddy proxied /api/* to the co-located Node server. The V2 marketing
// site is a STANDALONE STATIC build with no server of its own, so those
// relative paths would resolve against the static host and 404. Every API
// call therefore goes through an absolute origin.
//
// Override per-build with VITE_API (e.g. http://localhost:3001 in dev, or a
// preview API). Unset → the production V2 API.
export const API = import.meta.env.VITE_API || 'https://api.tempdash.app'
